import { getCurrentInstance } from 'vue';

export * from './useAuth';
export * from './useForm';
export * from './useStore';
export * from './useRouter';
export * from './useFormatting';
export * from './useSystemTheme';
export * from './useVuetify';

export const useEmit = () => {
  const vm = getCurrentInstance().proxy;

  return vm.$root.$emit;
};

export const _ = null;
